import { render, staticRenderFns } from "./BillInvoicePrint.vue?vue&type=template&id=9220dd18"
import script from "./BillInvoicePrint.vue?vue&type=script&lang=js"
export * from "./BillInvoicePrint.vue?vue&type=script&lang=js"
import style0 from "./BillInvoicePrint.vue?vue&type=style&index=0&id=9220dd18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports